const TrailNames = {
  CIRCLE_TRAIL: "CIRCLE_TRAIL",
};

export default TrailNames;
